export default {
  namespaced: true,
  state:{
    dailyLettersReferences: [],
    dailyLettersReferenceCreate: {
      modal: false,
      values: {}
    },
    dailyLettersReferenceEdit: {
      modal: false,
      values: {}
    }
  },
  getters:{
    dailyLettersReferences(state){
      return state.dailyLettersReferences;
    },
    dailyLettersReferenceCreate(state) {
        return state.dailyLettersReferenceCreate;
    },
    dailyLettersReferenceEdit(state) {
      return state.dailyLettersReferenceEdit;
    }
  },
  mutations:{
    SET_DAILY_LETTERS_REFERENCES(state, values){
      state.dailyLettersReferences = values;
    },
    SET_DAILY_LETTERS_REFERENCE_CREATE_MODAL(state, value) {
      state.dailyLettersReferenceCreate.modal = value;
    },
    SET_DAILY_LETTERS_REFERENCE_CREATE_VALUES(state, value) {
      state.dailyLettersReferenceCreate.values = value;
    },
    SET_DAILY_LETTERS_REFERENCE_EDIT_MODAL(state, value) {
      state.dailyLettersReferenceEdit.modal = value;
    },
    SET_DAILY_LETTERS_REFERENCE_EDIT_VALUES(state, value) {
      state.dailyLettersReferenceEdit.values = value;
    },
    PUSH_DAILY_LETTERS_REFERENCE(state, value){
      state.dailyLettersReferences.push(value);
    },
    SET_UPDATE_DAILY_LETTERS_REFERENCE(state, values){
      var editedIndex = state.dailyLettersReferences.map(reference => reference.id).indexOf(values.id);
      if (editedIndex > -1){
        Object.assign(state.dailyLettersReferences[editedIndex], values);
      }
      return;
    },
    SPLICE_DAILY_LETTERS_REFERENCE(state, value){
      let i = state.dailyLettersReferences.map(reference => reference.id).indexOf(value);
      state.dailyLettersReferences.splice(i, 1);
    }
  },
  actions:{
    getDailyLettersReferences({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/daily-letters-references').then((response) => {
          commit('SET_DAILY_LETTERS_REFERENCES', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    dailyLettersReferenceStore({commit}, payload) {
      const formData = new FormData();
      for(var key in payload) {
          formData.append(key, payload[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post('admin/daily-letters-references', formData).then((response) => {
          commit('PUSH_DAILY_LETTERS_REFERENCE', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    dailyLettersReferenceUpdate({commit}, payload) {
      var value = payload.id;
      return new Promise((resolve, reject) => {
        axios.put('admin/daily-letters-references/' + value, payload).then((response) => {
          commit('SET_UPDATE_DAILY_LETTERS_REFERENCE', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    deleteDailyLettersReference({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.delete('admin/daily-letters-references/' + value).then((response) => {
          commit('SPLICE_DAILY_LETTERS_REFERENCE', value);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
  }
}
